// extracted by mini-css-extract-plugin
module.exports = {"Container":"Header_Container__rCZfZ","ImgLogo":"Header_ImgLogo__1AyKF"};